import Site from 'es/app/business-logic/domain-models/Site';
import Guid from 'es/core/types/Guid';
import { IUser } from 'es/app/business-logic/domain-models/User';
import { ContactType } from 'es/app/__generated__/global';

export enum PersonType {
    Contact = 'CONTACT',
    User = 'USER',
}

export enum UserAccountStatus {
    Unused = 'UNUSED',
    Active = 'ACTIVE',
    Orphan = 'OPRHAN',
}

export interface IContact {
    id: Guid;
    user?: IUser | null;
    firstName: string | null;
    lastName: string | null;
    emailAddress: string | null;
    mobileNumber: string | null;
    type: ContactType;
}

export interface IContactWithMembership extends IContact {
    memberOf: Site[];
}

export interface IPersonSummary {
    id: Guid;
    type: PersonType | null;
    firstName: string | null;
    lastName: string | null;
    emailAddress: string | null;
    mobileNumber: string | null;
    status: UserAccountStatus;
}

export class Contact implements IContact {
    id!: Guid;
    user?: IUser;
    firstName = '';
    lastName = '';
    emailAddress = '';
    mobileNumber = '';
    type = ContactType.Default;

    toString() {
        return `${this.firstName} ${this.lastName}`;
    }
}

export class ContactWithMembership extends Contact implements IContactWithMembership {
    memberOf = [];
}
